/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step_Connect_NameInputs */

const en_landing_step_connect_name = /** @type {(inputs: Landing_Step_Connect_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect & Scale`)
};

/**
* | output |
* | --- |
* | "Connect & Scale" |
*
* @param {Landing_Step_Connect_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_step_connect_name = /** @type {((inputs?: Landing_Step_Connect_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step_Connect_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_step_connect_name(inputs)
});